import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_Hr.scss';

/**
 * A hr element component which wraps a HTML hr and adds to it the basic bootstrap css rules.
 * All arbitrary DOM properties and attributes (including event handlers) are accepted and passed to HTML hr element.
 */
const Hr = props => {
  const { className, innerRef, ...rest } = props;
  const classes = classNames('B360Hr', className);
  return <hr className={classes} ref={innerRef} {...rest} />;
};

Hr.propTypes = {
  /**
   * A custom className for the component
   */
  className: PropTypes.string,
  /**
   * a ref handled by the native html element
   */
  innerRef: PropTypes.func
};

export default Hr;
